import { useState, useRef } from 'react'

import { useApolloClient } from '@apollo/client'
import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { GetCurrentDocument } from 'generated/resources/graphql'
import Select from 'modules/core/components/Inputs/Select'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'
import app from 'modules/core/store/models/app'

import DiscoverabilityForm from 'modules/settings/lib/forms/DiscoverabilityWidget'

const DiscoverabilityWidgetSettings = () => {
  const { access } = useCurrentSession()
  const [loading, setLoading] = useState(false)
  const apolloClient = useApolloClient()

  const discoverabilityForm = useRef(
    new DiscoverabilityForm({
      hints: access.discoverabilityWidgetValue
    })
  ).current

  const options = [
    { label: i18n.t('personal_settings.discoverability_widget.true'), value: true },
    { label: i18n.t('personal_settings.discoverability_widget.false'), value: false }
  ]

  const onSubmit = async () => {
    const value = discoverabilityForm.get('hints').value
    setLoading(true)

    try {
      const api = ApiClient()
      await api.post(`/accesses/${access.id}/change_discoverability_widget`, {
        hints: value
      })

      await apolloClient.refetchQueries({ include: [GetCurrentDocument] })
      discoverabilityForm.cleanAll()

      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully')
      })
    } catch (error) {
      console.error(error)
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error')
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Section.Form
      illustration="window-star"
      title={i18n.t('personal_settings.discoverability_widget.title')}
      description={i18n.t('personal_settings.discoverability_widget.description')}
      onSubmit={onSubmit}
      submitLabel={i18n.t('common.submit')}
      isDirty={discoverabilityForm.isDirty}
      disabled={loading}
    >
      <Select
        label={i18n.t('personal_settings.discoverability_widget.title')}
        options={options}
        field={discoverabilityForm.get('hints')}
      />
    </Section.Form>
  )
}

export default observer(DiscoverabilityWidgetSettings)
